import React, { useState } from 'react';
import VideoModal from "./VideoModal";

const HowItWorksSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePlayClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-[960px] mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-extrabold text-[#050B15]">From scattered evidence to defensible assurance — fast.</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16">
            <div className="text-center group">
              <div className="w-16 h-16 bg-white shadow-sm rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100 relative group-hover:scale-110 transition-transform">
                <span className="material-symbols-outlined text-[#0077C8] text-2xl">cloud_upload</span>
                <span className="absolute -top-1 -right-1 w-6 h-6 bg-[#0077C8] text-white rounded-full flex items-center justify-center text-xs font-black">1</span>
              </div>
              <h4 className="font-bold text-[#050B15] mb-2">Upload framework</h4>
              <p className="text-xs text-gray-500">Upload your control framework (COSO-aligned or internal).</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-white shadow-sm rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100 relative group-hover:scale-110 transition-transform">
                <span className="material-symbols-outlined text-[#0077C8] text-2xl">attach_file</span>
                <span className="absolute -top-1 -right-1 w-6 h-6 bg-[#0077C8] text-white rounded-full flex items-center justify-center text-xs font-black">2</span>
              </div>
              <h4 className="font-bold text-[#050B15] mb-2">Attach evidence</h4>
              <p className="text-xs text-gray-500">Link existing files, logs, and screenshots directly.</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-white shadow-sm rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100 relative group-hover:scale-110 transition-transform">
                <span className="material-symbols-outlined text-[#0077C8] text-2xl">auto_awesome</span>
                <span className="absolute -top-1 -right-1 w-6 h-6 bg-[#0077C8] text-white rounded-full flex items-center justify-center text-xs font-black">3</span>
              </div>
              <h4 className="font-bold text-[#050B15] mb-2">Structure and assess</h4>
              <p className="text-xs text-gray-500">Organise evidence against specific Provision 29 criteria.</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-white shadow-sm rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100 relative group-hover:scale-110 transition-transform">
                <span className="material-symbols-outlined text-[#0077C8] text-2xl">download</span>
                <span className="absolute -top-1 -right-1 w-6 h-6 bg-[#0077C8] text-white rounded-full flex items-center justify-center text-xs font-black">4</span>
              </div>
              <h4 className="font-bold text-[#050B15] mb-2">Export</h4>
              <p className="text-xs text-gray-500">One-click defensible report for the Board and external auditors.</p>
            </div>
          </div>
          <div 
            className="w-full aspect-video bg-[#1B1B1B] rounded-2xl relative overflow-hidden flex items-center justify-center shadow-2xl group border border-gray-200 cursor-pointer"
            style={{
              backgroundImage: "linear-gradient(rgba(0,119,200,0.1), rgba(10,25,47,0.8)), url('https://lh3.googleusercontent.com/aida-public/AB6AXuAg1EHNDzbp-vtc2EBb2ViVFBqJICTYRdFTcg_MVHJfiXhKBFmrcH9Fclgtqh9gdL04c10BDrYmJfkQvvZIA8tgKyMuGqO_Ri2PFf4cu-zU9zVTgIe1KQuJNZ6YHwCtXDMDSV5l5a4EDOOrKKVVKRnrIuljK5GxkNJdTpalzWBQm-19KhRp0xdl6VZH5d1E6y_hb2YTjR6gtwzZToiNd_B_MpxHGk4K2fBbMEEeiBhqnzTAXVjVJbjclhL5NCkvPnAhTaiXJ8uBFxd8')",
              backgroundSize: 'cover'
            }}
            onClick={handlePlayClick}
          >
            <div className="absolute inset-0 bg-[#0077C8]/10 group-hover:bg-[#0077C8]/5 transition-colors"></div>
            <button 
              className="w-24 h-24 bg-[#0077C8] text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-2xl z-10"
              onClick={(e) => {
                e.stopPropagation();
                handlePlayClick();
              }}
            >
              <span className="material-symbols-outlined text-5xl leading-none">play_arrow</span>
            </button>
            <div className="absolute bottom-8 left-8 text-left z-10">
              <p className="text-xs uppercase tracking-[0.2em] text-[#0077C8] font-bold mb-2">Walkthrough</p>
              <p className="text-base font-semibold text-white">How Miporis secures Board-level confidence</p>
            </div>
          </div>
        </div>
      </section>

      <VideoModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        videoSrc={`${process.env.PUBLIC_URL || ''}/MIPORIS V_FINAL.mp4`}
      />
    </>
  );
};

export default HowItWorksSection;
